const ExclamationMarkCircle = () => {
  const exclamationCircleIcon = (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.3507 22.7693L27.447 32.6474C27.4295 32.7714 27.3674 32.8849 27.2724 32.9666C27.1774 33.0483 27.056 33.0927 26.9307 33.0915L24.9967 33.1003C24.8714 33.1016 24.7499 33.0572 24.6549 32.9755C24.5599 32.8938 24.4979 32.7803 24.4803 32.6563L23.5767 22.7781V22.7059L23.6128 11.2941C23.6207 11.1626 23.6786 11.0391 23.7746 10.9489C23.8706 10.8586 23.9975 10.8085 24.1292 10.8087L27.9066 10.7998C28.0383 10.7996 28.1652 10.8497 28.2612 10.94C28.3572 11.0302 28.4151 11.1537 28.423 11.2852L28.3558 22.697C28.3491 22.7204 28.3474 22.7451 28.3507 22.7693Z"
        fill="#CCDBF0"
      />
      <path
        d="M27.7387 41.1872L24.1162 41.1961C23.9793 41.1961 23.8479 41.1417 23.7511 41.0449C23.6543 40.948 23.5999 40.8167 23.5999 40.6798V36.6211C23.5999 36.4842 23.6543 36.3528 23.7511 36.256C23.8479 36.1591 23.9793 36.1047 24.1162 36.1047L27.8833 36.0958C28.0202 36.0958 28.1516 36.1503 28.2484 36.2471C28.3453 36.3439 28.3997 36.4753 28.3997 36.6122V40.5314C28.4018 40.6186 28.3861 40.7053 28.3536 40.7861C28.3211 40.867 28.2724 40.9404 28.2105 41.0018C28.1487 41.0632 28.0749 41.1113 27.9938 41.1432C27.9126 41.1751 27.8258 41.1901 27.7387 41.1872Z"
        fill="#CCDBF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.9998 51.5999C40.1383 51.5999 51.5998 40.1384 51.5998 25.9999C51.5998 11.8615 40.1383 0.399994 25.9998 0.399994C11.8614 0.399994 0.399902 11.8615 0.399902 25.9999C0.399902 40.1384 11.8614 51.5999 25.9998 51.5999ZM25.9998 48.3999C38.371 48.3999 48.3998 38.3711 48.3998 25.9999C48.3998 13.6288 38.371 3.59999 25.9998 3.59999C13.6287 3.59999 3.5999 13.6288 3.5999 25.9999C3.5999 38.3711 13.6287 48.3999 25.9998 48.3999Z"
        fill="#CCDBF0"
      />
    </svg>
  );
  return exclamationCircleIcon;
};

export default ExclamationMarkCircle;
